/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setStep, handleStepBack, handleNextStep, setIsInEdit, setSelectedAllTrue, setSelectedAllFalse, setSelectedDamagePhotoTypes, setDamagePosition, saveDamageSelected, setGlassTooltip, setGlassDrillDown } from '../../../actions/claimSubmitActions';
import { showSelectedDamageCar, showSelectedDamageMB } from '../../../actions/modalActions';
import { setTimeShow } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import './DamageReportDrillDown.css';
// Sets an initial global setTimeout to be cleared by the info bar
let infobarTimer = setTimeout(() => { }, 0);

/* TEMPORARY DEV GUIDE NOTES
// Will be removed when dev is completed 

// Function Guide - which functions do what:
damageReportDrillDownStart() - Start here - sets the Starting View + Damage Point Descriptions damage points states
setDamageReportDrillDownView() - Changes the view state (which view to show) + activates info bar if a view has starting text in the info bar
setDamagePointDescription() - For the info bar - passes text and styling and class values and hides the info bar after a time
handleSelectDamagePosGLASSClaims() - Does infobar stuff + handles the damage point as per the previous FNOL Damage page implementation

*/

class DamageReportDrillDown extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            damageIsInEdit: false,
            damagehasLoaded: false,
        }
        this.handleSelectDamagePos = this.handleSelectDamagePos.bind(this);
        this.checkDamageNext = this.checkDamageNext.bind(this);
        this.handleEditSelectedDamage = this.handleEditSelectedDamage.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleSubmitDamageReportStep1 = this.handleSubmitDamageReportStep1.bind(this);
        this.handleSubmitDamageStep1 = this.handleSubmitDamageStep1.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
        this.setDamageReportDrillDownView = this.setDamageReportDrillDownView.bind(this);
        this.handleSelectDamagePosGLASSClaims = this.handleSelectDamagePosGLASSClaims.bind(this);
        this.defaultDamagePointDescription = this.defaultDamagePointDescription.bind(this);
        this.setDamagePointDescription = this.setDamagePointDescription.bind(this);
        this.damageReportDrillDownStart = this.damageReportDrillDownStart.bind(this);
        this.handleSelectDamage = this.handleSelectDamage.bind(this);
        this.handleIsDamageSelected = this.handleIsDamageSelected.bind(this);
        this.handleIsDamageSelectedInfoBar = this.handleIsDamageSelectedInfoBar.bind(this);
    } 

    async handleSubmitDamageReportStep1() {
        await this.props.dispatchSetGlassTooltip("");
        await this.props.dispatchSetGlassDrillDown(false, "");
    }

    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    checkDamageNext() {
        if (this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) {
            this.setState({ continueDamage: true })
        }
        else if (this.state.selectAll) {
            this.setState({ continueDamage: false })
        }
        else if (this.props.claimSubmit.selectedDamagePhotoTypes.length > 0) {
            this.setState({ continueDamage: false })
        }
    }

    handleSubmitDamageStep1() {
        this.props.dispatchHandleNextStep();
    }

    async setDamageReportDrillDownView(whichViewToDisplay) {
        /* Resets the info bar content if a previous view had info bar content */
        await this.setState({ damageAreaSelectedDescription: false });
        await this.setState({ whichDamageReportDrillDownView: whichViewToDisplay });
        let checkStartingViewforInfoTextStart = this.state.whichDamageReportDrillDownView;
        /* Display corresponding Starting View InfoBar Description */
        switch (checkStartingViewforInfoTextStart) {
            case "front":
                this.setState({ damageAreaSelectedDescription: this.state.damagePointDescriptionFrontWindscreen });
                break;
            case "back":
                this.setState({ damageAreaSelectedDescription: this.state.damagePointDescriptionBackWindow });
                break;
            default:
                break;
        }
    }

    async defaultDamagePointDescription() {
        await this.props.dispatchSetGlassTooltip("");
    }

    async setDamagePointDescription(whichdamagePointDescriptionText) {
        /// Ensures that if a previous damage point was clicked that it's timeout is cleared
        clearTimeout(infobarTimer);
        /// Displays InfoBar Damage Point Description text
        await this.props.dispatchSetGlassTooltip(whichdamagePointDescriptionText);
        /// Remove the setTimeout below if you don't want the info bar to show the default text after select.
        infobarTimer = setTimeout(
            () => {
                this.defaultDamagePointDescription();
            }, 3000);
    }

    async damageReportDrillDownStart() {
        await this.setState({
            damagePointDescriptionFrontRightWindow: "Front right window",
            damagePointDescriptionFrontRightVentQuarter: "Front right vent / quarter",
            damagePointDescriptionFrontLeftWindow: "Front left window",
            damagePointDescriptionFrontLeftVentQuarter: "Front left vent / quarter",
            damagePointDescriptionFrontWindscreen: "Windscreen",
            damagePointDescriptionBackRightWindow: "Back right window",
            damagePointDescriptionBackRightQuarter: "Back right quarter",
            damagePointDescriptionBackRightVent: "Back right vent",
            damagePointDescriptionBackLeftWindow: "Back left window",
            damagePointDescriptionBackLeftQuarter: "Back left quarter",
            damagePointDescriptionBackLeftVent: "Back left vent",
            damagePointDescriptionBackWindow: "Back window"
        });

        this.setDamageReportDrillDownView("back-right");
        
    }

    componentWillMount() {
        this.damageReportDrillDownStart();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    async handleSelectAll() {
        if (this.state.selectAll) {
            await this.setState({
                selectAll: false
            })
            this.props.dispatchSetSelectedAllFalse();
        }
        else {
            await this.setState({ selectAll: true })
            this.props.dispatchSetSelectedAllTrue();
        }
        await this.checkDamageNext();
    }

    async handleSelectDamage(description) {
        await this.setDamagePointDescription(description);
        await this.props.dispatchSaveDamageSelected(description);
    }

    handleIsDamageSelected(description) {
        let response = "/my-policy/Images/FNOL/damage-button-nugreen.png"
        for (let i = 0; i < this.props.claimSubmit.claimDamagePhotoTypes.length; i++) {
            if (this.props.claimSubmit.claimDamagePhotoTypes[i].description.toLowerCase() === description.toLowerCase()) {
                if (this.props.claimSubmit.claimDamagePhotoTypes[i].isSelected) {
                     response = "/my-policy/Images/FNOL/damage-button-red.png";
                }
                break;
            }
        }
        return response;
    }

    handleIsDamageSelectedInfoBar(description) {
        let response = 'glassclaims-info-bar-unselected '
        for (let i = 0; i < this.props.claimSubmit.claimDamagePhotoTypes.length; i++) {
            if (this.props.claimSubmit.claimDamagePhotoTypes[i].description.toLowerCase() === description.toLowerCase()) {
                if (this.props.claimSubmit.claimDamagePhotoTypes[i].isSelected) {
                    response = 'glassclaims-info-bar-selected ';
                }
                break;
            }
        }
        return response;
    }

    async handleEditSelectedDamage() {
        await this.setState({ damageIsInEdit: !this.state.damageIsInEdit });
    }

    async handleSelectDamagePos(pos: string) {
        await this.setState({ damageIsInEdit: false });
        await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
        this.setDamagePointDescription(pos);
        await this.checkDamageNext();
    }

    async handleSelectDamagePosGLASSClaims(pos: string, damagePointSelectedDescription) {
        /*NOTE: Content for this should be replaced with actual GlassClaim links to the Drilldown pages for each section*/
        /* await this.setState({ damageIsInEdit: false });
         await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
         this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar(pos) : await this.props.dispatchShowSelectedDamageMB(pos);
         await this.checkDamageNext();*/

        /// Keep this to pass the Position name (for targetted styling + damagePointSelectedDescription text)
        this.setDamagePointDescription(damagePointSelectedDescription);
    }

    public render(): JSX.Element {
        let damageDetailList = <div></div>;
        let damageSelectImgTitle = "Click to show us where the damage area is";
        if (this.props.claimSubmit.hasDamageSelected) {
            damageDetailList = this.props.claimSubmit.claimDamagePhotoTypes.filter((photo) => photo.isSelected === true && photo.location === this.props.claimSubmit.selectedGlassDrilldown).map((photoType) => {
                return <>
                    <div className={"row fnol-damage-detail-actual-item-row " + (this.state.damageIsInEdit ? "fnol-damage-detail-edityes" : "fnol-damage-detail-editno")} onClick={() => this.handleSelectDamage(photoType.description)} title={(this.state.damageIsInEdit ? "Click to remove this item" : "Click on the 'Edit pen' icon to remove this item")}>
                        <div className="col fnol-damage-detail-actual-item-text-col">
                            <span>{photoType.description}</span>
                        </div>
                        <div className="fnol-damage-detail-actual-item-icon-col">
                            <img alt="" src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/red-checkmark-cross.svg" : "/my-policy/Images/Claims/grey-checkmark-checked.svg"} />
                        </div>
                    </div>
                </>
            });
        }
        return (
            <>
                <div className="fnol-preload">
                    <img src="/my-policy/Images/Claims/Numbers/number-3-red-32x32px.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/Progress/progress-circle-nugreen.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/Progress/progress-circle-red.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-right-desktop.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-right-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-left-desktop.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-left-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-desktop.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-front-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-desktop.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-left-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-left-desktop.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-right-mobile.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-back-right-desktop.svg" alt="" title="" />
                </div>
                <div className="col ssp-container-fnol-glass ssp-container-fnol-step-header-padding">
                    <div className="row noma">
                        <div className="col-12 nopa ssp-header-fnol-glass">
                            <div className="row noma">
                                <div className="fnol-step-header-icon-area">
                                    <img src='/my-policy/Images/Claims/Numbers/number-3-red-32x32px.svg' alt="Step 3" title="Step 3" />
                                </div>
                                <div className="col fnol-step-header-title-area">
                                    {
                                        (!this.props.claimSubmit.selectedGlassDrilldown) &&
                                        <h3>Damage report Drilldown Default</h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "frontRight") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            front right
                                        </h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "frontLeft") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            front left
                                        </h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "front") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            front
                                        </h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "backRight") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            back right
                                        </h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "backLeft") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            back left
                                        </h3>
                                    }
                                    {
                                        (this.props.claimSubmit.selectedGlassDrilldown === "back") &&
                                        <h3>
                                            Damage report:&nbsp;
                                            <br className="glassclaims-mobile-br" />
                                            back
                                        </h3>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 fnol-steps-info-section-holder">
                            <hr className="hr-minus21px" />
                            <p className="fnol-damage-report-intro-p">
                                {!this.props.claimSubmit.selectedGlassDrilldown &&
                                    <>
                                        Nothing Selected. Please make a selection.
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "frontRight") &&
                                    <>
                                        Take a look at the image below and select which of your front right windows have been damaged
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "frontLeft") &&
                                    <>
                                        Take a look at the image below and select which of your front left windows have been damaged
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "front") &&
                                    <>
                                        Take a look at the image below and select whether your windscreen has been damaged
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "backRight") &&
                                    <>
                                        Take a look at the image below and select which of your back right windows have been damaged
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "backLeft") &&
                                    <>
                                        Take a look at the image below and select which of your back left windows have been damaged
                                    </>
                                }
                                {(this.props.claimSubmit.selectedGlassDrilldown === "back") &&
                                    <>
                                        Take a look at the image below and select whether your back window has been damaged
                                    </>
                                }
                            </p>
                            <div className="fnol-damage-report-legend-container">
                                <div className="fnol-damage-report-legend-1">
                                    <img alt="Not damaged" title="Not damaged" src="/my-policy/Images/FNOL/Progress/progress-circle-nugreen.svg" />
                                    <span>Not damaged</span>
                                </div>
                                <div className="fnol-damage-report-legend-2">
                                    <img alt="Damaged" title="Damaged" src="/my-policy/Images/FNOL/Progress/progress-circle-red.svg" />
                                    <span>Damaged</span>
                                </div>
                            </div>
                            {/*/// Temporary Tester / Dev View Control - remove this Row Div block when development has been completed ///*/}
                            {/*<div className="row noma">*/}
                            {/*    <div className="col nopa">*/}
                            {/*        <fieldset>*/}
                            {/*            <legend><b>Damage View Controls. Selected State:</b> {this.state.whichDamageReportDrillDownView}</legend>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('front-right')}>Front Right</button>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('front-left')}>Front Left</button>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('front')}>Front</button>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('back-right')}>Back Right</button>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('back-left')}>Back Left</button>*/}
                            {/*            <button onClick={() => this.setDamageReportDrillDownView('back')}>Back</button>*/}
                            {/*        </fieldset>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*/// INFO BAR ///*/}
                            <div className="row noma glassclaims-info-bar-row">
                                <div className="col nopa">
                                    <div className={"glassclaims-info-bar-actual-holder " + " " + "glassclaims-info-bar-active-view-" + this.props.claimSubmit.selectedGlassDrilldown + " " + (this.props.claimSubmit.lastSelectedDamage !== "" ? 'glassclaims-info-bar-selected ' : '')}>
                                        <span className="glassclaims-info-bar-span">
                                            Select the damaged area/s
                                        </span>
                                        {(this.props.claimSubmit.lastSelectedDamage) &&
                                            <>
                                                <div className="glassclaims-info-bar-text-overlay">
                                                    <div className="row noma align-items-center">
                                                        <div className="col nopa">
                                                            <span className="glassclaims-info-bar-span glassclaims-info-bar-span-overlay">
                                                                {this.props.claimSubmit.lastSelectedDamage}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/*/// DAMAGE VEHICLE SECTIONS BELOW: ///*/}
                            {/*/// GLASS CLAIMS ///*/}
                            {/*/// Front-Right ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "frontRight") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-front-right">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-right-window" onClick={() => this.handleSelectDamage('Front right window')} src={this.handleIsDamageSelected('Front right window')} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="front-right-vent-quarter" onClick={() => this.handleSelectDamage('Front right vent')} src={this.handleIsDamageSelected('Front right vent')} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }
                            {/*/// Front-Left ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "frontLeft") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-front-left">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                            <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-left-window" onClick={() => this.handleSelectDamage('Front left window')} src={this.handleIsDamageSelected('Front left window')} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="front-left-vent-quarter" onClick={() => this.handleSelectDamage('Front left vent')} src={this.handleIsDamageSelected('Front left vent')} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }
                            {/*/// Front ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "front") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-front">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-windscreen" onClick={() => this.handleSelectDamage('Windshield')} src={this.handleIsDamageSelected('Windshield')} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }
                            {/*/// Back Right ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "backRight") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-back-right">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="back-right-window" onClick={() => this.handleSelectDamage('Back right window')} src={this.handleIsDamageSelected('Back right window')} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="back-right-quarter" onClick={() => this.handleSelectDamage('Back right quarter')} src={this.handleIsDamageSelected('Back right quarter')} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-3" id="back-right-vent" onClick={() => this.handleSelectDamage('Back right vent')} src={this.handleIsDamageSelected('Back right vent')} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }
                            {/*/// Back Left ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "backLeft") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-back-left">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="back-left-window" onClick={() => this.handleSelectDamage('Back left window')} src={(this.handleIsDamageSelected('Back left window'))} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="back-left-quarter" onClick={() => this.handleSelectDamage('Back left quarter')} src={(this.handleIsDamageSelected('Back left quarter'))} />
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-3" id="back-left-vent" onClick={() => this.handleSelectDamage('Back left vent')} src={(this.handleIsDamageSelected('Back left vent'))} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }
                            {/*/// Back ///*/}
                            {(this.props.claimSubmit.selectedGlassDrilldown === "back") &&
                                <div className="fnol-damage-report-car-bike-containers-holder glassclaims-damage-drilldown-back">
                                    <>
                                        <div className="damage-report-image-outer-container">
                                            <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="back-window" onClick={() => this.handleSelectDamage('Back window')} src={(this.handleIsDamageSelected('Back window'))} />
                                            </div>
                                        </div>
                                    </>
                                </div>
                            }

                            {/*/// SELECT ALL REMAINS COMMENTED FOR NOW.  ///*/}
                            {/* Here if it is decided to utilise it for Damage Report Drilldown */}
                            {/*<div className={"fnol-damage-report-select-all " + (this.props.claimSubmit.isCar ? ' fnol-damage-report-select-all-iscar' : 'fnol-damage-report-select-all-isnotcar')}>
                                <div className="row checkAll" onClick={this.handleSelectAll} title="Click to select/deselect all">
                                    <div className="checkAllimgcol">
                                        <img alt="" src={this.state.selectAll ? '/my-policy/Images/FNOL/Rectangle-checked.svg' : '/my-policy/Images/FNOL/Rectangle-unchecked.svg'} />
                                    </div>
                                    <div className="col checkAlltextcol">
                                        <div className="checkAlltext">Select all</div>
                                    </div>
                                </div>
                            </div>*/}

                            {this.props.claimSubmit.hasDamageSelected &&
                                <div className={"damageSelectedHoldingDiv " + (this.props.claimSubmit.hasDamageSelected ? "damageSelectedHoldingDiv-show" : "damageSelectedHoldingDiv-hide")}>
                                    <>
                                        <div className="col-12 nopa">
                                            <div className="row glassclaims-damage-detail-hr-row">
                                                <div className="col-12 nopa">
                                                    <hr className="hr-minus5px" />
                                                </div>
                                            </div>
                                            <div className="row fnol-damage-detail-header-row" title="Click to start removing items below" onClick={this.handleEditSelectedDamage}>
                                                <div className="col nopa fnol-damage-detail-text-col">
                                                    <h3>Damage detail {this.handleSelectDamagePos} {this.props.claimSubmit.hasDamageSelected}</h3>
                                                </div>
                                                <div className="nopa fnol-damage-detail-icon-col">
                                                    <img alt="" className="arrow" src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/Edit-pen-red.svg" : "/my-policy/Images/Claims/Edit-pen-grey.svg"} />
                                                </div>
                                            </div>
                                            {damageDetailList}
                                        </div>
                                    </>
                                </div>
                            }
                            <div className="nopa fnol-steps-buttonholder">
                                <button className="btn btn-solid-red fnol-buttonreverse-button-next" onClick={this.handleSubmitDamageReportStep1}>Next</button>
                                <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleSubmitDamageReportStep1}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchIsInEdit: (isEdit) => dispatch(setIsInEdit(isEdit)),
        dispatchShowSelectedDamageCar: (position) => dispatch(showSelectedDamageCar(position)),
        dispatchShowSelectedDamageMB: (position) => dispatch(showSelectedDamageMB(position)),
        dispatchSetSelectedAllTrue: () => dispatch(setSelectedAllTrue()),
        dispatchSetSelectedAllFalse: () => dispatch(setSelectedAllFalse()),
        dispatchAddDamagePosition: (pos) => dispatch(setDamagePosition(pos)),
        dispatchSetSelectedDamagePhotoTypes: (riskItemType) => dispatch(setSelectedDamagePhotoTypes(riskItemType)),
        dispatchSaveDamageSelected: (description) => dispatch(saveDamageSelected(description)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetGlassTooltip: (damageDescription) => dispatch(setGlassTooltip(damageDescription)),
        dispatchSetGlassDrillDown: (drillDownEnabled, location) => dispatch(setGlassDrillDown(drillDownEnabled, location)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DamageReportDrillDown)